/** 付款金流 */
export enum EPayment {
  /** 綠界 */
  ECPAY = 'ecpay',
  /** 藍星 */
  NEWEBPAY = 'newebpay',
  /** PAYUNi 統一金流 */
  PAYUNI = 'payuni',
  /** PayNow */
  PAYNOW = 'paynow',
  /** 銀角(中租) */
  CHAILEASE = 'chailease',
  /** 遠信 */
  FAR_TRUST = 'farTrust',
  /** Pay4U (和潤) */
  PAY4U = 'pay4u',
  /** 轉帳 */
  TRANSFER = 'transfer',
}

export const PAYMENT_LABEL: Record<EPayment, string> = {
  [EPayment.ECPAY]: '綠界',
  [EPayment.NEWEBPAY]: '藍新',
  [EPayment.PAYUNI]: 'PAYUNi 統一金流',
  [EPayment.PAYNOW]: 'PayNow',
  [EPayment.CHAILEASE]: '銀角',
  [EPayment.FAR_TRUST]: '遠信',
  [EPayment.PAY4U]: '和潤',
  [EPayment.TRANSFER]: '轉帳',
};

/**
 * 付款方式
 *  - NO_CASH_TRADE: 0元訂單功能尚未規劃完成，依 PM 決議關閉，暫時註解保留以備未來重新啟用 (jira: #ONECLUB-13103)。
 */
export enum EPaymentMethod {
  /** 信用卡 */
  CREDIT = 'credit',
  /** 銀角零卡分期 (中租) */
  NO_CARD = 'noCard',
  /** 遠信免卡分期 */
  FAR_TRUST_NO_CARD = 'farTrustNoCard',
  /** 0元訂單 */
  // NO_CASH_TRADE = 'noCashTrade',
  /** 轉帳付款 */
  TRANSFER = 'transfer',
  /** 定期定額 */
  COST_AVERAGING = 'costAveraging',
  /** 和潤無卡分期 */
  PAY4U_NO_CARD = 'pay4uNoCard',
  /** 綠界TWQR */
  TWQR = 'twqr',
}

export type TPaymentMethod =
  | EPaymentMethod.CREDIT
  | EPaymentMethod.NO_CARD
  | EPaymentMethod.FAR_TRUST_NO_CARD
  | EPaymentMethod.TRANSFER
  | EPaymentMethod.COST_AVERAGING
  | EPaymentMethod.PAY4U_NO_CARD
  | EPaymentMethod.TWQR;

export const PAYMENT_METHOD_LABEL: Record<EPaymentMethod, string> = {
  [EPaymentMethod.CREDIT]: '信用卡',
  [EPaymentMethod.NO_CARD]: '銀角零卡分期',
  [EPaymentMethod.FAR_TRUST_NO_CARD]: '遠信免卡分期',
  [EPaymentMethod.TRANSFER]: '轉帳付款',
  [EPaymentMethod.COST_AVERAGING]: '定期定額',
  [EPaymentMethod.PAY4U_NO_CARD]: '和潤無卡分期',
  [EPaymentMethod.TWQR]: 'TWQR',
};
